import React, {useEffect, useState} from 'react';
import {toast, ToastContainer} from "react-toastify";
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import Spinner from "reactjs-simple-spinner";
import {Link} from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import SettingsService from "../../../services/SettingsService";


const AgeLimits = () => {

    const [loading, setLoading] = useState(false);
    const [updateLoading, setUpdateLoading] = useState(false);
    const [settings, setSettings] = useState({});
    const [ageLimit, setAgeLimit] = useState({
        relationship: '', age_limit: 0
    })
    const [policyHolderAge, setPolicyHolderAge] = useState(0)
    const [spouseAge, setSpouseAge] = useState(0)
    const [childAge, setChildAge] = useState(0)
    const [parentAge, setParentAge] = useState(0)
    const [extendedAge, setExtendedAge] = useState(0)

    const updateAgeLimits = () => {
        setUpdateLoading(true);
        let request;
        console.log(ageLimit);
        if (ageLimit.relationship === 'PARENT') {
            request = {"parent_max_age": ageLimit.age_limit}
        } else if (ageLimit.relationship === 'CHILD') {
            request = {"child_max_age": ageLimit.age_limit}
        } else if (ageLimit.relationship === 'SPOUSE') {
            request = {"spouse_max_age": ageLimit.age_limit}
        } else if (ageLimit.relationship === 'POLICY_HOLDER') {
            request = {"policy_holder_max_age": ageLimit.age_limit}
        } else if (ageLimit.relationship === 'EXTENDED_FAMILY') {
            request = {"extended_family_max_age": ageLimit.age_limit}
        }

        console.log("request payload: ", request);

        SettingsService.updateSettings(request).then(res => {
            console.log("res: ", res)
            if (res.status === 200) {
                SettingsService.getSettings().then(response => {
                    console.log(response);
                    if (response === undefined) {
                        setSettings({})
                        toast.warning('✅ Age limit Updated, 🚫 Failed to get data ', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        setUpdateLoading(false);
                    }
                    setSettings(response.data.data[0]);
                    setPolicyHolderAge(response.data.data[0].policy_holder_max_age)
                    setParentAge(response.data.data[0].parent_max_age)
                    setSpouseAge(response.data.data[0].spouse_max_age)
                    setChildAge(response.data.data[0].child_max_age)
                    setExtendedAge(response.data.data[0].extended_family_max_age)
                    toast('✅ Age limit Updated ', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setUpdateLoading(false);

                    //   console.log();                                                                                        );
                }).catch(err => {
                    console.log(err);
                    setSettings({})
                    toast.warning('✅ Age limit Updated , 🚫 Failed to get data ', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setUpdateLoading(false);
                });

            } else {
                toast.warning('🚫 Failed to update age limit ' + res.response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setUpdateLoading(false);
            }
        })
            .catch((err) => {
                console.log("error: ", err)
                toast.warning('🚫 Failed to update age limit ' + err.response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setUpdateLoading(false);
            })

    }

    useEffect(() => {
        setLoading(true);
        setUpdateLoading(false);
        SettingsService.getSettings()
            .then(res => {
                console.log(res)
                if (res === undefined) {
                    setSettings({})
                    setLoading(false)
                }
                setSettings(res.data.data[0]);
                setPolicyHolderAge(res.data.data[0].policy_holder_max_age)
                setParentAge(res.data.data[0].parent_max_age)
                setSpouseAge(res.data.data[0].spouse_max_age)
                setChildAge(res.data.data[0].child_max_age)
                setExtendedAge(res.data.data[0].extended_family_max_age)
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setSettings([])
                setLoading(false)
            })
    }, [])

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div
                id="main-content" className="main-panel ps-container ps-theme-default">
              <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                <div className="content">
                    <div className="container-fluid">
                        <div className="container">

                                <div className="main-body">

                                    <nav aria-label="breadcrumb" className="main-breadcrumb">
                                        <ol className="breadcrumb">
                                            <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a>
                                            </Link>
                                            &nbsp;|&nbsp;
                                            <Link to="/settings"><a href><i
                                                className="fa fa-cog"/>&nbsp;Settings</a></Link>
                                            &nbsp;|&nbsp;
                                            <li className="breadcrumb-item">Age Limits</li>
                                        </ol>
                                    </nav>

                                    {loading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="large"
                                                message="Getting Data,Please wait....."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>
                                    )}
                                    {updateLoading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="large"
                                                message="Updating Limits,Please wait....."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>
                                    )}

                                    {!loading && !updateLoading && (
                                        <div className="row gutters-sm">

                                            <div className="col-md-12">
                                                <div className="card mb-3">
                                                    <div className="card-body">
                                                        <h4 className="font-weight-bold">Age Limit Management</h4>
                                                        <div className="row">
                                                            <div className="col-sm-3">
                                                                <h6 className="mb-0">Enter Policy Holder Age Limit</h6>
                                                                <h6>Current Limit: <span className="text-primary">
                                                                {settings.policy_holder_max_age}
                                                            </span></h6>
                                                            </div>
                                                            <div className="col-sm-9 text-secondary">

                                                                <TextField
                                                                    margin="dense"
                                                                    label="Type Age Limit"
                                                                    type="number"
                                                                    fullWidth
                                                                    value={policyHolderAge}
                                                                    onChange={(e) => {
                                                                        setAgeLimit({
                                                                            relationship: 'POLICY_HOLDER',
                                                                            age_limit: parseInt(e.target.value)
                                                                        })
                                                                        setPolicyHolderAge(parseInt(e.target.value))
                                                                    }
                                                                    }
                                                                />
                                                                <button
                                                                    onClick={updateAgeLimits}
                                                                    className="btn btn-sm btn-outline-primary">
                                                                    Change Age Limit
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-sm-3">
                                                                <h6 className="mb-0">Enter Spouse Age Limit</h6>
                                                                <h6>Current Limit: <span className="text-primary">
                                                                {settings.spouse_max_age}
                                                            </span></h6>
                                                            </div>
                                                            <div className="col-sm-9 text-secondary">

                                                                <TextField
                                                                    margin="dense"
                                                                    label="Type Age Limit"
                                                                    type="number"
                                                                    fullWidth
                                                                    value={spouseAge}
                                                                    onChange={(e) => {
                                                                        setAgeLimit({
                                                                            relationship: 'SPOUSE',
                                                                            age_limit: parseInt(e.target.value)
                                                                        })
                                                                        setSpouseAge(parseInt(e.target.value))
                                                                    }
                                                                    }
                                                                />
                                                                <button
                                                                    onClick={updateAgeLimits}
                                                                    className="btn btn-sm btn-outline-primary">
                                                                    Change Age Limit
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-sm-3">
                                                                <h6 className="mb-0">Enter Child Age Limit</h6>
                                                                <h6>Current Limit: <span className="text-primary">
                                                                {settings.child_max_age}
                                                            </span></h6>
                                                            </div>
                                                            <div className="col-sm-9 text-secondary">

                                                                <TextField
                                                                    margin="dense"
                                                                    label="Type Age Limit"
                                                                    type="number"
                                                                    fullWidth
                                                                    value={childAge}
                                                                    onChange={(e) => {
                                                                        setAgeLimit({
                                                                            relationship: 'CHILD',
                                                                            age_limit: parseInt(e.target.value)
                                                                        })
                                                                        setChildAge(parseInt(e.target.value))
                                                                    }
                                                                    }
                                                                />
                                                                <button
                                                                    onClick={updateAgeLimits}
                                                                    className="btn btn-sm btn-outline-primary">
                                                                    Change Age Limit
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-sm-3">
                                                                <h6 className="mb-0">Enter Parent Age Limit</h6>
                                                                <h6>Current Limit: <span className="text-primary">
                                                                {settings.parent_max_age}
                                                            </span></h6>
                                                            </div>
                                                            <div className="col-sm-9 text-secondary">

                                                                <TextField
                                                                    margin="dense"
                                                                    label="Type Age Limit"
                                                                    type="number"
                                                                    fullWidth
                                                                    value={parentAge}
                                                                    onChange={(e) => {
                                                                        setAgeLimit({
                                                                            relationship: 'PARENT',
                                                                            age_limit: parseInt(e.target.value)
                                                                        })
                                                                        setParentAge(parseInt(e.target.value))
                                                                    }
                                                                    }
                                                                />
                                                                <button
                                                                    onClick={updateAgeLimits}
                                                                    className="btn btn-sm btn-outline-primary">
                                                                    Change Age Limit
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-sm-3">
                                                                <h6 className="mb-0">Enter Extended Family Age
                                                                    Limit</h6>
                                                                <h6>Current Limit: <span className="text-primary">
                                                                {settings.extended_family_max_age}
                                                            </span></h6>
                                                            </div>
                                                            <div className="col-sm-9 text-secondary">

                                                                <TextField
                                                                    margin="dense"
                                                                    label="Type Age Limit"
                                                                    type="number"
                                                                    fullWidth
                                                                    value={extendedAge}
                                                                    onChange={(e) => {
                                                                        setAgeLimit({
                                                                            relationship: 'EXTENDED_FAMILY',
                                                                            age_limit: parseInt(e.target.value)
                                                                        })
                                                                        setExtendedAge(parseInt(e.target.value))
                                                                    }

                                                                    }
                                                                />
                                                                <button
                                                                    onClick={updateAgeLimits}
                                                                    className="btn btn-sm btn-outline-primary">
                                                                    Change Age Limit
                                                                </button>
                                                            </div>
                                                        </div>

                                                        <hr/>

                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    )}
                                </div>


                        </div>
                    </div>
                </div>

            </div>

        </>
    )
}

export default AgeLimits
